import { ref } from 'vue'
import type { Report, FellowReport } from '@/types/reports'
import { API_ROUTES } from '@/const/apiRoutes'
import api from '@/utils/api'

export function useReportActions(report: Report | FellowReport) {
  const isSubmitting = ref(false)

  const rejectReport = async () => {
    if (!report) return

    isSubmitting.value = true
    try {
      const response = await api.patch(API_ROUTES.REVIEW_FELLOW_REPORT(report.id.toString()), {
        status: 'REJECTED',
        review_notes: 'Report does not constitute a violation of guidelines'
      })
      return response.data
    } catch (error) {
      console.error('Error rejecting report:', error)
      throw error
    } finally {
      isSubmitting.value = false
    }
  }

  const issueStrike = async (data: { severity: string; review_notes?: string }) => {
    if (!report) return

    isSubmitting.value = true
    try {
      const response = await api.patch(API_ROUTES.REVIEW_FELLOW_REPORT(report.id.toString()), {
        status: 'APPROVED',
        severity: data.severity,
        review_notes: data.review_notes
      })
      return response.data
    } catch (error) {
      console.error('Error issuing strike:', error)
      throw error
    } finally {
      isSubmitting.value = false
    }
  }

  const revokeStrike = async (data: { reason: string }) => {
    if (!report) return

    isSubmitting.value = true
    try {
      const response = await api.post(API_ROUTES.REVOKE_FELLOW_REPORT(report.id.toString()), {
        reason: data.reason
      })
      return response.data
    } catch (error) {
      console.error('Error revoking strike:', error)
      throw error
    } finally {
      isSubmitting.value = false
    }
  }

  return {
    isSubmitting,
    rejectReport,
    issueStrike,
    revokeStrike
  }
} 